import './Inputs.scss'

const CheckboxInput = ({ labelColor, label, id, ...props }: any) => {
  return (
    <div className={`checkbox-input ${props.disabled && 'disabled'}`}>
      <label className={`checkbox-input__label`}>
        <input className={`checkbox-input__input`} type='checkbox' {...props} />
        <div className='checkmark' style={{ background: props.checked && labelColor }} />
        {label || ''}
      </label>
    </div>
  )
}

export default CheckboxInput
